__turbopack_context__.v({
  "background": "Hero-module-scss-module__VGZQoq__background",
  "content": "Hero-module-scss-module__VGZQoq__content",
  "copy": "Hero-module-scss-module__VGZQoq__copy",
  "fade-in": "Hero-module-scss-module__VGZQoq__fade-in",
  "foreground": "Hero-module-scss-module__VGZQoq__foreground",
  "headline": "Hero-module-scss-module__VGZQoq__headline",
  "inner": "Hero-module-scss-module__VGZQoq__inner",
  "isInView": "Hero-module-scss-module__VGZQoq__isInView",
  "lockup": "Hero-module-scss-module__VGZQoq__lockup",
  "root": "Hero-module-scss-module__VGZQoq__root",
  "videoBug": "Hero-module-scss-module__VGZQoq__videoBug",
  "videoBugButton": "Hero-module-scss-module__VGZQoq__videoBugButton",
  "videoBugContainerMobile": "Hero-module-scss-module__VGZQoq__videoBugContainerMobile",
  "videoBugDesktop": "Hero-module-scss-module__VGZQoq__videoBugDesktop",
  "videoBugIcon": "Hero-module-scss-module__VGZQoq__videoBugIcon",
  "videoBugInner": "Hero-module-scss-module__VGZQoq__videoBugInner",
  "videoBugMobile": "Hero-module-scss-module__VGZQoq__videoBugMobile",
  "videoBugTextural": "Hero-module-scss-module__VGZQoq__videoBugTextural",
});
